import { render, staticRenderFns } from "./BranceImages.vue?vue&type=template&id=647349c9&"
import script from "./BranceImages.vue?vue&type=script&lang=js&"
export * from "./BranceImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports